import Bullet from 'components/prism/bullet';
import { ArrayHelpers, Paging, SystemText } from 'e4shared';
import React from 'react';
import { Link } from 'react-router-dom';

export const ToDo = ({ text, data, profileId, hasPathway, hasBehaviours }) => {
    const pageSize = 3;
    const [page, setPage] = React.useState(1);

    return (
        <>
            <div className="flex flex-center mb10">
                <h2>
                    {text.title}
                    <span className="ml10" style={{ fontWeight: 400 }}>
                        {data?.length}
                    </span>
                </h2>
            </div>
            {ArrayHelpers.getPage(data, page, pageSize).map(item => {
                let link = '';
                let type = '';
                let subType = '';

                switch (item.type) {
                    case 'review':
                        type = 'review';
                        link = `/develop/reviews/${profileId}`;
                        item.name = SystemText('Welcome/ToDo/ReviewTitle');
                        item.description = SystemText('Welcome/ToDo/ReviewSummary');
                        break;
                    default: // must be an objective
                        type = 'objective';
                        subType = item.type;
                        link = `/objectives/${profileId}/objective/${item.id}`;
                        break;
                }

                return (
                    <Link
                        data-testid="todo-item"
                        key={`todo-${item.type}-${item.id}`}
                        to={link}
                        className="prism-content-box mt10"
                    >
                        <div className="prism-content">
                            <div className="flex flex-center">
                                <Bullet type={type} subType={subType} />
                                <h4 className="ml10">{item.name}</h4>
                            </div>
                            {item.description && <p className="truncate-4">{item.description}</p>}
                            <div>
                                <Bullet isDate value={item.due} />
                                {item.duration > 0 && (
                                    <span className="ml10">
                                        <Bullet isDuration value={item.duration} />
                                    </span>
                                )}
                            </div>
                        </div>
                    </Link>
                );
            })}
            {data.length > pageSize && (
                <div className="mt10 text-center welcome-paging">
                    <Paging recordCount={data.length} page={page} pageSize={pageSize} goToPage={setPage} />
                </div>
            )}
            {data.length === 0 && (
                <div className="flex flex-center flex-column pt10 pb10">
                    <i className="fa fa-check-square" style={{ fontSize: '48px' }} />
                    <h4 className="mt20 mb10">{hasPathway ? text.noResultsPathway : text.noResults}</h4>
                    <span>
                        {hasPathway
                            ? text.noResultsSummaryPathway
                            : hasBehaviours
                            ? text.noResultsSummaryBehaviours
                            : text.noResultsSummary}
                    </span>
                </div>
            )}
        </>
    );
};

export default ToDo;
